import type { HelpFile } from '../../types/help'
import { ResourcesTestIds } from '../../../testids/ResourcesTestIds'

export const resourcesHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [ResourcesTestIds.resourcesList]:
      'Alle in den Zielsystemen definierten Ressourcen — Datensätze, Ordner, Anwendungen und andere Objekte, auf die Zugriffsprofile vergeben werden.',
    [ResourcesTestIds.btnNewResource]:
      'Neue Ressource vom festgelegten Typ anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs ab.',
  },
}
